(function () {
    'use strict';

    angular
        .module('sodNotificationCenter')
        .directive('sodNotificationCenterDir', sodNotificationCenterDir);

    function sodNotificationCenterDir() {
        return {
            restrict: 'A',
            controller: sodNotificationCenterDirCtrl,
            controllerAs: 'noti',
            bindToController: true,
            scope: {}
        };
    }

    function sodNotificationCenterDirCtrl() {
        var vm = this;

    }
})();